import './dashboard'
import './device_list'
import './disable'
import './enable'
import './update'
import './signup'
import './confirm_code'
